var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9H4.5V18H18.5V9Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.75C12.1904 14.75 12.75 14.1904 12.75 13.5C12.75 12.8096 12.1904 12.25 11.5 12.25C10.8096 12.25 10.25 12.8096 10.25 13.5C10.25 14.1904 10.8096 14.75 11.5 14.75Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9V5C15.5 3.93913 15.0786 2.92172 14.3284 2.17157C13.5783 1.42143 12.5609 1 11.5 1C10.4391 1 9.42172 1.42143 8.67157 2.17157C7.92143 2.92172 7.5 3.93913 7.5 5V9",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 24C7.32843 24 8 23.3284 8 22.5C8 21.6716 7.32843 21 6.5 21C5.67157 21 5 21.6716 5 22.5C5 23.3284 5.67157 24 6.5 24Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 24C12.3284 24 13 23.3284 13 22.5C13 21.6716 12.3284 21 11.5 21C10.6716 21 10 21.6716 10 22.5C10 23.3284 10.6716 24 11.5 24Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24C17.3284 24 18 23.3284 18 22.5C18 21.6716 17.3284 21 16.5 21C15.6716 21 15 21.6716 15 22.5C15 23.3284 15.6716 24 16.5 24Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 24C22.3284 24 23 23.3284 23 22.5C23 21.6716 22.3284 21 21.5 21C20.6716 21 20 21.6716 20 22.5C20 23.3284 20.6716 24 21.5 24Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 24C2.32843 24 3 23.3284 3 22.5C3 21.6716 2.32843 21 1.5 21C0.671573 21 0 21.6716 0 22.5C0 23.3284 0.671573 24 1.5 24Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassw);
export default __webpack_public_path__ + "static/media/passw.fb403d87.svg";
export { ForwardRef as ReactComponent };